export const getStyles = (theme: any, isDisabled?: boolean) => ({
  styles: {
    deleteButton: {
      position: "absolute",
      zIndex: 1,
      right: "11px",
      top: "8px",
      width: "32px",
      height: "32px",
      backgroundColor: theme.palette.grey[0],
    },

    checkBox: {
      position: "absolute",
      zIndex: 1,
      right: "11px",
      top: "8px",
    },
    cardContent: {
      backgroundColor: theme.palette.grey[900],
      height: "60px",
      maxHeight: "60px",
      marginBottom: theme.spacing(1.5),
    },
    nameTypography: {
      color: theme.palette.grey[0],
      textTransform: "capitalize",
      lineHeight: "16px",
      display: "block",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      width: "100%",
    },
    priceTypography: {
      color: theme.palette.grey[300],
      textTransform: "capitalize",
      lineHeight: "16px",
    },
    trashIcon: {
      color: "transparent",
      "& path": { stroke: theme.palette.grey[500] },
    },
    cardMediaDefault: {
      minWidth: "124px",
      minHeight: "192px",
      opacity: isDisabled ? "0.5" : "1",
    },
    cardMediaRealtime: {
      minWidth: "124px",
      minHeight: "192px",
      opacity: isDisabled ? "0.5" : "1",
    },
    cardClick: {
      pointerEvents: isDisabled ? "none" : "auto",
    },
  },
});
